module.exports = __webpack_public_path__ + "static/media/doctor-search_p3_1.920498d8.png";